import { AppMenu, AppUserMenu } from '@/api/models';
import { UserMenuSchema } from './UserPermissionHelper';
import { isProductionEnv } from '@/utils';

export interface IMenuSettings {
  tourBag: boolean;
  order: boolean;
  orders: boolean;
  shaft: boolean;
  inventory: boolean;
  masterList: boolean;
  admin: boolean;
  wgr: boolean;
}

interface IGetUserMenuSettingsProps {
  appMenus: AppMenu[];
  userMenus: AppUserMenu[];
  userMenuSchema: UserMenuSchema;
}

export const getUserMenuSettings = ({ userMenus, appMenus, userMenuSchema }: IGetUserMenuSettingsProps) => {
  const userMenuIds = new Set(userMenus.map((u) => u.appMenuId));

  // Returns true if the user has access to any child or nested descendant of the given menu.
  const hasChildAccess = (appMenuId: number): boolean => {
    const stack = [appMenuId];

    while (stack.length > 0) {
      const currentId = stack.pop()!;
      const children = appMenus.filter((m) => m.parentAppMenuId === currentId);

      for (const child of children) {
        if (userMenuIds.has(child.appMenuId)) return true;
        stack.push(child.appMenuId);
      }
    }

    return false;
  };

  const isMenuVisible = (menuId?: number) => (menuId ? hasChildAccess(menuId) : false);

  // a parent menu is considered visible if the user has access to any of its child or nested descendant menus.
  // WGR is a leaf menu, so its visibility is determined by whether the user has direct access to it.
  const menuSettings: IMenuSettings = {
    tourBag: isMenuVisible(userMenuSchema.Tour.appMenuId),
    order: isMenuVisible(userMenuSchema.Order.appMenuId),
    orders: !isProductionEnv && isMenuVisible(userMenuSchema.Order.appMenuId),
    shaft: isMenuVisible(userMenuSchema.Shaft.appMenuId),
    inventory: isMenuVisible(userMenuSchema.Inventory.appMenuId),
    masterList: isMenuVisible(userMenuSchema.MasterList.appMenuId),
    admin: isMenuVisible(userMenuSchema.Admin.appMenuId),
    wgr: Boolean(userMenus.find((menu) => menu.appMenuId === userMenuSchema.WGR.appMenuId)),
  };

  return menuSettings;
};
